import React, { useContext, useRef, useState } from "react";
import { Col, Row, Card, Table } from "@themesberg/react-bootstrap";
import { TableRow } from "../component/TableRow";
import Pagination from "../../../../components/Pagination";
import { Context } from "../Period";
import AddResultPopup from "../sub-screen/add-result-popup/AddResultPopup";
import AddMienBacResultPopup from "../sub-screen/add-result-popup/AddMienBacResultPopup";
import CalculateRewardPopup from "../sub-screen/calculate-reward-popup/CalculateRewardPopup";

const _Table = ({ region }) => {
  const { state, dispatch } = useContext(Context);

  const [addPopupShow, setAddPopupShow] = useState(false);

  const [modalCalculateRewardShow, setModalCalculateRewardShow] =
    useState(false);

  const [calculateRewardResultId, setCalculateRewardResultId] = useState(null);

  const resultIdRef = useRef(null);

  const resultRef = useRef(null);

  const symbolRef = useRef('');

  const resultCallbackRef = useRef(() => {});

  const canUpdateResultRef = useRef(false)

  const onShowAddPopupPress = (id, result, callback, canUpdate, symbol) => {
    resultIdRef.current = id;
    resultRef.current = result;
    symbolRef.current = symbol || '';
    canUpdateResultRef.current = canUpdate;
    resultCallbackRef.current = callback;
    setAddPopupShow(true);
  };

  const onShowCalculateRewardPopupPress = (resultId) => {
    setCalculateRewardResultId(resultId);
    setModalCalculateRewardShow(true);
  };

  const onHideCalculateRewardPopupPress = (
    totalRewardTicket,
    totalUnrewardTicket,
    totalUmRewardTicket,
    totalUmUnrewardTicket,
    callback,
    jobComplete = false,
  ) => {
    const rid = calculateRewardResultId;
    callback();
    if (rid != null && rid !== "") {
      dispatch({
        type: "PATCH_CLASSIC_PERIOD_RESULT_ROW",
        payload: {
          resultId: rid,
          fields: {
            totalRewaredTickets: Number(totalRewardTicket) || 0,
            totalUnRewardTickets: Number(totalUnrewardTicket) || 0,
            totalRewaredUnmarketableTickets: Number(totalUmRewardTicket) || 0,
            totalUnRewardUnmarketableTickets: Number(totalUmUnrewardTicket) || 0,
            ...(jobComplete ? { status: 4 } : {}),
          },
        },
      });
    }
    setCalculateRewardResultId(null);
    setModalCalculateRewardShow(false);
  };

  return (
    <>
      <Card border="light" className="shadow-sm">
        <Table
          responsive
          className="align-items-center table-bordered table-hover"
        >
          <thead className="text-center">
            <tr>
              <th rowSpan={2} scope="col">
                Thao tác
              </th>
              <th rowSpan={2} scope="col">
                Thông tin
              </th>
              <th rowSpan={2} scope="col">
                Kết quả
              </th>
              <th rowSpan={2} scope="col">
                Thống kê vé
              </th>
              <th colSpan={3} scope="col">
                Số lượng
              </th>
            </tr>
            <tr>
              <th scope="col">Nhập</th>
              <th scope="col">Bán</th>
              <th scope="col">Còn lại</th>
            </tr>
          </thead>
          <tbody>
            {state.data.list &&
              state.data.list.map((pv, index) => (
                <TableRow
                  classicUser={state.data.classicUser}
                  onCalculateRewardPress={onShowCalculateRewardPopupPress}
                  handleAddResult={onShowAddPopupPress}
                  rIndex={index}
                  key={`table-keys-lottmekong-${pv.id}`}
                  {...pv}
                  region={region}
                />
              ))}
          </tbody>
        </Table>
        <Card.Footer className="flex-row">
          <Row className="align-items-center">
            <Col>
              <Pagination
                totalPage={state.data.totalPage || 0}
                currentPage={state.filter.page || 0}
                onPageChange={(i) => {
                  dispatch({
                    type: "UPDATE_PAGE",
                    payload: i,
                  });
                }}
              />
            </Col>
          </Row>
        </Card.Footer>
      </Card>
      {region === 'MB' ? (
        <AddMienBacResultPopup
          show={addPopupShow}
          id={resultIdRef.current}
          result={resultRef.current}
          symbol={symbolRef.current}
          callback={resultCallbackRef.current}
          canUpdate={canUpdateResultRef.current}
          onHide={() => {
            resultIdRef.current = null;
            resultCallbackRef.current = () => {};
            setAddPopupShow(false);
          }}
        />
      ) : (
        <AddResultPopup
          show={addPopupShow}
          id={resultIdRef.current}
          result={resultRef.current}
          callback={resultCallbackRef.current}
          canUpdate={canUpdateResultRef.current}
          onHide={() => {
            resultIdRef.current = null;
            resultCallbackRef.current = () => {};
            setAddPopupShow(false);
          }}
        />
      )}
      <CalculateRewardPopup
        show={modalCalculateRewardShow}
        resultId={calculateRewardResultId}
        region={region}
        onHide={onHideCalculateRewardPopupPress}
      />
    </>
  );
};

export default _Table;
